import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';

import { DealerItem } from './DealerItem';

export const StateSection = ({ state, locations }) => {
	const sectionClassNames = setClassNames([
		// first 2 styles needed in combination with column-count (see main.scss)
		'd-inline-block',
		'w-100',
		'my-5'
	]);
	const listClassNames = setClassNames([
		'list-unstyled',
		'ddc-font-size-small',
		'mb-0'
	]);
	const sanitizedLocations = locations
		.map((location) => ({
			name: location.name ?? '',
			city: location.address.city ?? '',
			id: location.id ?? ''
		}))
		.sort((loc1, loc2) => {
			const sortKey1 = `${loc1.city.toLowerCase()} ${loc1.name.toLowerCase()}`;
			const sortKey2 = `${loc2.city.toLowerCase()} ${loc2.name.toLowerCase()}`;
			return sortKey1.localeCompare(sortKey2);
		});

	return (
		<section
			className={sectionClassNames}
			key={state}
			aria-labelledby={`state-heading-${state}`}
		>
			<h5 className="mt-0" id={`state-heading-${state}`}>
				{state}
			</h5>
			<ul className={listClassNames} aria-label={`Locations in ${state}`}>
				{sanitizedLocations.map((location) => (
					<DealerItem
						name={location.name}
						city={location.city}
						locationId={location.id}
						key={location.id}
					/>
				))}
			</ul>
		</section>
	);
};

StateSection.propTypes = {
	state: PropTypes.string.isRequired,
	locations: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
			address: PropTypes.shape({
				city: PropTypes.string.isRequired
			}).isRequired
		})
	).isRequired
};
